<template>
    <div class="custom-product-section" data-testid="custom-product" :class="{'lab-note-active': isLabNotesActive}">
        <MdButton class="md-icon-button md-dense remove-product tablet" @click="$emit('removeProduct')">
            <base-icon icon-name="add"/>
        </MdButton>
        <input-area
            data-print="disabled"
            name="add-step"
            tag="textarea"
            :label="customContent.title || 'Description'"
            v-model="customContent.desc"
            @inputChanged="updateCustomDesc"
            class="add-step-textarea"
            maxlength=400
        />

        <div v-html="printableCustomDesc" class="printable-description" data-print="enabled" />
    </div>
</template>
<script>
export default {
    name: 'CustomProduct',
    props: {
        customContent: {
            type: Object,
            required: true,
        },
        stepInfo: {
            type: Object,
            required: true,
        },
        isLabNotesActive: {
            type: Boolean
        }
    },
    methods: {
        updateCustomDesc() {
            const {name, key} = this.stepInfo;
			this.$store.dispatch('workflow/setCustomProdDesc', {name, key, desc: this.customContent.desc});
			this.$root.$emit('changeRegistered');
		},
    },
    computed: {
        printableCustomDesc() {
            return this.customContent.desc
                .split('\n')
                .filter((paragraph) => paragraph)
                .map((paragraph) => `<p>${paragraph}</p>`)
                .toString()
                .replace(/,/g, '');
        },
    }
}
</script>
<style lang="scss">
.custom-product-section {
    flex: 1  854px;
    padding: 20px 20px 36px 0;
    &.lab-note-active {
        @media screen and (min-width: $mobile + 1) {
            padding-right: 0;
        }
    }
    textarea {
        max-height: 300px;
    }
    @media only screen and (max-width: $mobile) {
        padding: 24px 16px 38px 16px;
    }
    @media (min-width: $mobile + 1) and (max-width: $tablet) {
        padding-right: 0;
        margin-bottom: 8px;
    }
    .printable-description[data-print='enabled'] {
            visibility: hidden;
            display:none;
            height: 0px;
            margin: 12px 0;

            p {
                padding: 0 !important;
                margin: 0 !important;
                word-break: break-all;
            }
	}
}

</style>
